module.exports = {
  publicPath: (process.env.VUE_APP_STAGE && process.env.VUE_APP_STAGE !== 'production') ? `/${process.env.VUE_APP_STAGE}/` : '/',
  outputDir: 'dist',
  assetsDir: 'static',
  lintOnSave: false,
  transpileDependencies: [
    '@gdev/card-payment',
    'vue-router',
    '@vue/devtools-api'
  ],
  chainWebpack: config => {
    config.module.rules.delete('eslint');
  },
  configureWebpack: {
    module: {
      rules: [
        {
          test: /\.m?js$/,
          include: /node_modules\/@gdev\/card-payment/,
          use: {
            loader: 'babel-loader',
            options: {
              presets: ['@babel/preset-env']
            }
          }
        }
      ]
    }
  },
  devServer: {
    host: 'localhost',
    port: 8080,
    historyApiFallback: {
      index: '/dev/index.html',
      rewrites: [
        { from: /^\/dev\/.*/, to: '/dev/index.html' },
        { from: /^\/dev$/, to: '/dev/' }
      ]
    }
  }
}
